export var OBTAIN_BASIC_INFO;
(function (OBTAIN_BASIC_INFO) {
    // obtainDefaultInfo
    OBTAIN_BASIC_INFO["\uBC1C\uD589\uC77C"] = "\uBC1C\uD589\uC77C";
    OBTAIN_BASIC_INFO["\uD504\uB85C\uC81D\uD2B8\uCF54\uB4DC"] = "\uD504\uB85C\uC81D\uD2B8 \uCF54\uB4DC";
    OBTAIN_BASIC_INFO["\uC0AC\uB0B4\uACAC\uC801\uBC88\uD638"] = "\uC0AC\uB0B4 \uACAC\uC801\uBC88\uD638";
    OBTAIN_BASIC_INFO["\uAE30\uC5C5\uBCC4\uC785\uCC30\uBC88\uD638"] = "\uAE30\uC5C5\uBCC4 \uC785\uCC30\uBC88\uD638";
    // obtainDefaultInfo2
    OBTAIN_BASIC_INFO["\uB0A9\uAE30\uC77C"] = "\uB0A9\uAE30\uC77C";
    OBTAIN_BASIC_INFO["\uC778\uB3C4\uC870\uAC74"] = "\uC778\uB3C4\uC870\uAC74";
    OBTAIN_BASIC_INFO["\uD504\uB85C\uC81D\uD2B8\uBA85"] = "\uD504\uB85C\uC81D\uD2B8\uBA85";
    OBTAIN_BASIC_INFO["\uD504\uB85C\uC81D\uD2B8\uAE30\uAC04"] = "\uD504\uB85C\uC81D\uD2B8 \uAE30\uAC04";
    OBTAIN_BASIC_INFO["\uD2B9\uC774\uC0AC\uD56D"] = "\uD2B9\uC774\uC0AC\uD56D";
    // _estimateSearchCompanyInfoInputs
    OBTAIN_BASIC_INFO["\uC5C5\uCCB4\uBA85"] = "\uC5C5\uCCB4\uBA85";
    OBTAIN_BASIC_INFO["\uB2F4\uB2F9\uC790"] = "\uB2F4\uB2F9\uC790";
    OBTAIN_BASIC_INFO["\uB2F4\uB2F9\uC790\uC774\uBA54\uC77C"] = "\uB2F4\uB2F9\uC790 E-mail";
    OBTAIN_BASIC_INFO["\uB2F4\uB2F9\uC790\uC5F0\uB77D\uCC98"] = "\uB2F4\uB2F9\uC790 \uC5F0\uB77D\uCC98";
    // _estimateFilesInputs
    OBTAIN_BASIC_INFO["\uC2B9\uC778\uC11C"] = "\uC2B9\uC778\uC11C";
    OBTAIN_BASIC_INFO["\uB3C4\uBA74"] = "\uB3C4\uBA74";
    OBTAIN_BASIC_INFO["\uC218\uC8FC\uC11C"] = "\uC218\uC8FC\uC11C";
    OBTAIN_BASIC_INFO["\uAE30\uD0C0"] = "\uAE30\uD0C0";
})(OBTAIN_BASIC_INFO || (OBTAIN_BASIC_INFO = {}));
